
import { createContext, useContext, ReactNode } from 'react';
import { API_KEYS } from '@/utils/apiKeys';

interface ApiDirectContextProps {
  getApiKey: (featureId: string) => string;
  isApiKeyAvailable: (featureId: string) => boolean;
}

// Create a context to bypass the feature model
const ApiDirectContext = createContext<ApiDirectContextProps | undefined>(undefined);

// Provider component
export const ApiDirectProvider = ({ children }: { children: ReactNode }) => {
  // Function to get API key for a feature
  const getApiKey = (featureId: string): string => {
    if (featureId in API_KEYS.openai) {
      const key = API_KEYS.openai[featureId as keyof typeof API_KEYS.openai];
      return key || '';
    }
    return '';
  };

  // Function to check if API key is available
  const isApiKeyAvailable = (featureId: string): boolean => {
    const key = getApiKey(featureId);
    return !!key && key.length > 0;
  };

  const value = {
    getApiKey,
    isApiKeyAvailable
  };

  return (
    <ApiDirectContext.Provider value={value}>
      {children}
    </ApiDirectContext.Provider>
  );
};

// Hook to use the API direct context
export const useApiDirect = (): ApiDirectContextProps => {
  const context = useContext(ApiDirectContext);
  if (!context) {
    throw new Error('useApiDirect must be used within an ApiDirectProvider');
  }
  return context;
};
